import React from "react";
import { useSelector } from "react-redux";
import { JobViewGrid as SharedJobViewGrid } from "tap/components/JobViewGrid";
import { useJobsActions } from "tap/store/licensingJobs/useJobs.js";

export const JobViewGrid = () => {
  const {
    isJobViewModalOpen,
    jobViewFilterForm,
    jobViewTasks,
    selectedJob,
    taskStatusOptions,
    pendingStatuses,
    jobViewItemsPerPage,
    jobViewCurrentPage,
  } = useSelector((state) => state.licensingJobs);

  const { updateJobs, updateJobsSearchForm } = useJobsActions();

  return (
    <SharedJobViewGrid
      isJobViewModalOpen={isJobViewModalOpen}
      jobViewFilterForm={jobViewFilterForm}
      jobTasks={jobViewTasks}
      selectedJob={selectedJob}
      taskStatusOptions={taskStatusOptions}
      pendingStatuses={pendingStatuses}
      updateStore={updateJobs}
      updateSearchForm={updateJobsSearchForm}
      isLicensingJob={true}
      columnDefsKey="licensingJobTasks"
      tasksFieldName="jobViewTasks"
      itemsPerPage={jobViewItemsPerPage}
      currentPage={jobViewCurrentPage}
    />
  );
};
